import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/store";
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};
import error from "../components/error";
// 1.安装插件
Vue.use(VueRouter);

// 2.创建router
const router = new VueRouter({
  // mode: "history", // hash  history
  base: "/",
  routes: [
    {
      path: "/",
      redirect: "/main",
      name: "Main",
      component: (resolve) => require(["@/views/main/index"], resolve),
      children: [
        {
          path: "/",
          name: "Home",
          component: (resolve) => require(["@/views/home/index"], resolve),
          meta: {
            title: "舞侠 - 首页",
            regist: true,
            login: true,
            download: true,
            enter: true,
            ad: true,
            label: true,
            config: true,
            isMustLogin: false,
          },
        },
        {
          path: "/register",
          name: "Register",
          component: (resolve) => require(["@/views/register/index"], resolve),
          meta: {
            title: "舞侠 - 注册",
            download: true,
            enter: true,
            ad: true,
            label: true,
            config: true,
            isMustLogin: false,
          },
        },
        {
          path: "/login",
          name: "Login",
          component: (resolve) => require(["@/views/login/index"], resolve),
          meta: {
            title: "舞侠 - 登录",
            download: true,
            enter: true,
            ad: true,
            label: true,
            config: true,
            isMustLogin: false,
          },
        },
        {
          path: "/downLoad",
          name: "DownLoad",
          component: (resolve) => require(["@/views/downLoad/index"], resolve),
          meta: {
            title: "舞侠 - 下载中心",
            download: true,
            enter: true,
            ad: true,
            label: true,
            config: true,
            isMustLogin: false,
          },
        },
        {
          path: "/AppdownLoad",
          name: "AppDownLoad",
          component: (resolve) => require(["@/views/downLoad/load"], resolve),
          meta: {
            title: "舞侠 - 下载中心",
            download: true,
            enter: true,
            ad: true,
            label: true,
            config: true,
            isMustLogin: false,
          },
        },
        {
          path: "/account",
          name: "Account",
          component: (resolve) => require(["@/views/account/index"], resolve),
          meta: {
            title: "舞侠 - 账户中心",
            login: true,
            download: true,
            enter: true,
            record: true,
            ad: true,
            label: true,
            config: true,
            isMustLogin: true,
          },
        },
        {
          path: "/notice",
          name: "Notice",
          component: (resolve) => require(["@/views/notice/index"], resolve),
          meta: {
            title: "舞侠 - 公告",
            download: true,
            enter: true,
            record: true,
            ad: true,
            notice: true,
            isMustLogin: true,
          },
        },
        {
          path: "/ceremony",
          name: "Ceremony",
          component: (resolve) => require(["@/views/ceremony/index"], resolve),
          meta: {
            title: "舞侠 - 礼遇",
            login: true,
            download: true,
            enter: true,
            record: true,
            ad: true,
            isMustLogin: true,
          },
        },

        {
          path: "/daily",
          name: "Daily",
          component: (resolve) => require(["@/views/daily/index"], resolve),
          meta: {
            title: "舞侠 - 日常",
            login: true,
            download: true,
            enter: true,
            record: true,
            ad: true,
            isMustLogin: true,
          },
        },
        {
          path: "/news",
          name: "NewsList",
          component: (resolve) => require(["@/views/news/list"], resolve),
          meta: {
            title: "舞侠 - 新闻列表",
            login: true,
            download: true,
            enter: true,
            record: true,
            ad: true,
            isMustLogin: false,
            isMobile: true,
          },
        },
        {
          path: "/newsDetail",
          name: "NewsDetail",
          component: (resolve) => require(["@/views/news/detail"], resolve),
          meta: {
            title: "舞侠 - 新闻详情",
            login: true,
            download: true,
            enter: true,
            record: true,
            ad: true,
            isMustLogin: false,
            isMobile: true,
          },
        },
        {
          path: "/gameDetail",
          name: "GameDetail",
          component: (resolve) => require(["@/views/news/gameDetail"], resolve),
          meta: {
            title: "舞侠 - 新闻详情",
            login: true,
            download: true,
            enter: true,
            record: true,
            ad: true,
            isMustLogin: false,
          },
        },
        {
          path: "/recruit",
          name: "Recruit",
          component: (resolve) => require(["@/views/recruit/index"], resolve),
          meta: {
            title: "舞侠 - 招募",
            login: true,
            download: true,
            enter: true,
            record: true,
            ad: true,
            isMustLogin: true,
          },
        },
        {
          path: "/hallOfFame",
          name: "HallOfFame",
          component: (resolve) =>
            require(["@/views/hallOfFame/index"], resolve),
          meta: {
            title: "舞侠 - 名人堂",
            dance: true,
            bgm: true,
            hiddenRainbow: true,
            isMustLogin: true,
          },
        },
        {
          path: "/rank",
          name: "Rank",
          component: (resolve) => require(["@/views/rank/index"], resolve),
          meta: {
            title: "舞侠 - 热榜",
            dance: true,
            bgm: true,
            hiddenRainbow: true,
            isMustLogin: true,
          },
        },
        {
          path: "/record",
          name: "Record",
          component: (resolve) => require(["@/views/record/index"], resolve),
          meta: {
            title: "舞侠 - 记录",
            login: true,
            download: true,
            enter: true,
            record: true,
            ad: true,
            label: true,
            config: true,
            //rank:true,
            isMustLogin: true,
          },
        },
        {
          path: "/recharge",
          name: "Recharge",
          component: (resolve) => require(["@/views/recharge/index"], resolve),
          meta: {
            title: "舞侠 - 充值中心",
            login: true,
            download: true,
            enter: true,
            record: true,
            ad: true,
            label: true,
            config: true,
            rank: true,
            isMustLogin: true,
          },
        },
        {
          path: "/songChart",
          name: "SongChart",
          component: (resolve) => require(["@/views/songChart/index"], resolve),
          meta: {
            title: "舞侠 - 歌曲打榜",
            login: true,
            download: true,
            enter: true,
            record: true,
            ad: true,
            bgm: true,
            isMustLogin: true,
          },
        },
      ],
    },
    {
      path: "/demo",
      name: "Demo",
      component: (resolve) => require(["@/views/demo/index"], resolve),
      meta: {
        title: "demo",
      },
    },
    // {
    //   path: "/midAutumn",
    //   name: "midAutumn",
    //   component: (resolve) => require(["@/views/MidAutumnFestival/index"], resolve),
    //   meta: {
    //     title: "舞侠 - 中秋",
    //     login: true,
    //     download: true,
    //     enter: true,
    //     record: true,
    //     ad: true,
    //     bgm: true,
    //     isMustLogin: true,
    //   },
    // },

    // {
    //   path: "/shoppingFestival",
    //   name: "shoppingFestival",
    //   component: (resolve) => require(["@/views/DoubleEleven/index"], resolve),
    //   meta: {
    //     title: "舞侠 - 618",
    //     login: true,
    //     download: true,
    //     enter: true,
    //     record: true,
    //     ad: true,
    //     bgm: true,
    //     isMustLogin: true,
    //   },
    // },

    // {
    //   path: "/July",
    //   name: "July",
    //   component: (resolve) =>
    //     require(["@/views/DragonBoatFestival/index"], resolve),
    //   meta: {
    //     title: "舞侠 - 福满七月",
    //     login: true,
    //     download: true,
    //     enter: true,
    //     record: true,
    //     ad: true,
    //     isMustLogin: true,
    //   },
    // },
    // {
    //   path: "/throwinggame",
    //   name: "ThrowingGame",
    //   component: (resolve) => require(["@/views/ThrowingGame/index"], resolve),
    //   meta: {
    //     title: "舞侠 - 世界杯",
    //     login: true,
    //     download: true,
    //     enter: true,
    //     record: true,
    //     ad: true,
    //     bgm: true,
    //     isMustLogin: true,
    //   },
    // },
    // {
    //   path: "/Survey",
    //   name: "Survey",
    //   component: (resolve) => require(["@/views/Research/index"], resolve),
    //   meta: {
    //     title: "舞侠 - 有奖调研",
    //     login: true,
    //     download: true,
    //     enter: true,
    //     record: true,
    //     ad: true,
    //     bgm: true,
    //     isMustLogin: true,
    //   },
    // },
    // {
    //   path: "/Voting",
    //   name: "Voting",
    //   component: (resolve) => require(["@/views/Voting/index"], resolve),
    //   meta: {
    //     title: "舞侠 - 票选活动",
    //     login: true,
    //     download: true,
    //     enter: true,
    //     record: true,
    //     ad: true,
    //     bgm: true,
    //     isMustLogin: true,
    //   },
    // },
    // {
    //   path: "/GreatHeat",
    //   name: "GreatHeat",
    //   component: (resolve) => require(["@/views/ChildrenDay/index"], resolve),
    //   meta: {
    //     title: "舞侠 - 大暑献礼",
    //     login: true,
    //     download: true,
    //     enter: true,
    //     record: true,
    //     ad: true,
    //     isMustLogin: true,
    //   },
    // },
    // {
    //   path: "/Qingliang_yixia",
    //   name: "Qingliang_yixia",
    //   component: (resolve) => require(["@/views/Qingliang_yixia/index"], resolve),
    //   meta: {
    //     title: "舞侠 - 清凉一夏",
    //     login: true,
    //     download: true,
    //     enter: true,
    //     record: true,
    //     ad: true,
    //     isMustLogin: true,
    //   },
    // },
    {
      path: "/QixiFestival",
      name: "qixi",
      component: (resolve) => require(["@/views/Qixi/index"], resolve),
      meta: {
        title: "舞侠 - 炙热如我心",
        login: true,
        download: true,
        enter: true,
        record: true,
        ad: true,
        bgm: true,
        isMustLogin: true,
      },
    },
    {
      path: "/AutumnFestival",
      name: "AutumnFestival",
      component: (resolve) => require(["@/views/AutumnFestival/index"], resolve),
      meta: {
        title: "舞侠 - 中秋佳节",
        login: true,
        download: true,
        enter: true,
        record: true,
        ad: true,
        bgm: true,
        isMustLogin: true,
      },
    },
    // {
    //   path: "/NationalDay",
    //   name: "NationalDay",
    //   component: (resolve) => require(["@/views/NationalDay/index"], resolve),
    //   meta: {
    //     title: "舞侠 - 国庆",
    //     login: true,
    //     download: true,
    //     enter: true,
    //     record: true,
    //     ad: true,
    //     bgm: true,
    //     isMustLogin: true,
    //   },
    // },
    {
      path: "/OpeningCeremony",
      name: "OpeningCeremony",
      component: (resolve) => require(["@/views/OpeningCeremony/index"], resolve),
      meta: {
        title: "舞侠 - 开学典礼",
        login: true,
        download: true,
        enter: true,
        record: true,
        ad: true,
        bgm: true,
        isMustLogin: true,
      },
    },
    // {
    //   path: "/Christmas",
    //   name: "Christmas",
    //   component: (resolve) => require(["@/views/Christmas/index"], resolve),
    //   meta: {
    //     title: "舞侠 - 双旦",
    //     login: true,
    //     download: true,
    //     enter: true,
    //     record: true,
    //     ad: true,
    //     bgm: true,
    //     isMustLogin: true,

    //   },
    // },

    {
      path: "/exchange",
      name: "Exchange",
      component: (resolve) => require(["@/views/Exchange/index"], resolve),
      meta: {
        title: "舞侠 - 礼包兑换",
        login: true,
        download: true,
        enter: true,
        record: true,
        ad: true,
        bgm: true,
        isMustLogin: true,
      },
    },
    {
      path: "/SignIn",
      name: "SignIn",
      component: (resolve) => require(["@/views/SignIn/index"], resolve),
      meta: {
        title: "舞侠 - 签到",
        login: true,
        download: true,
        enter: true,
        record: true,
        ad: true,
        bgm: true,
        isMustLogin: true,
      },
    },
    {
      path: "/JewelryBox",
      name: "JewelryBox",
      component: (resolve) => require(["@/views/JewelryBox/index"], resolve),
      meta: {
        title: "舞侠 - 首饰盒",
        login: true,
        download: true,
        enter: true,
        record: true,
        ad: true,
        bgm: true,
        isMustLogin: true,
      },
    },

    // {
    //   path: "/dancing",
    //   name: "Dancing",
    //   component: (resolve) => require(["@/views/FreedomDancing/index"], resolve),
    //   meta: {
    //     title: "舞侠 - 自由舞会",
    //     login: true,
    //     download: true,
    //     enter: true,
    //     record: true,
    //     ad: true,
    //     bgm: true,
    //     isMustLogin: true,

    //   },
    // },

    // {
    //   path: "/Summer",
    //   name: "Summer",
    //   component: (resolve) => require(["@/views/Summer/index"], resolve),
    //   meta: {
    //     title: "舞侠 - 暑期",
    //     login: true,
    //     download: true,
    //     enter: true,
    //     record: true,
    //     ad: true,
    //     bgm: true,
    //     isMustLogin: true,
    //   },
    // },
    // {
    //   path: "/NewYear",
    //   name: "NewYear",
    //   component: (resolve) => require(["@/views/NewYear/index"], resolve),
    //   meta: {
    //     title: "舞侠 - 春节活动",
    //     login: true,
    //     download: true,
    //     enter: true,
    //     record: true,
    //     ad: true,
    //     bgm: true,
    //     isMustLogin: true,
    //   },
    // },

    {
      path: "/ConsumptionRank",
      name: "ConsumptionRank",
      component: (resolve) => require(["@/views/ConsumptionRank/index.vue"], resolve),
      meta: { title: "舞侠 - 消费排行榜" },
    },

    // {
    //   path: "/DoubleTwelve",
    //   name: "DoubleTwelve",
    //   component: (resolve) => require(["@/views/DoubleTwelve/index"], resolve),
    //   meta: {
    //     title: "舞侠 - 双十二",
    //     login: true,
    //     download: true,
    //     enter: true,
    //     record: true,
    //     ad: true,
    //     bgm: true,
    //     isMustLogin: true,
    //   },
    // },

    // {
    //   path: "/celebrate",
    //   name: "celebrate",
    //   component: (resolve) => require(["@/views/SpringFestival/index"], resolve),
    //   meta: {
    //     title: "舞侠 - 庆祝",
    //     login: true,
    //     download: true,
    //     enter: true,
    //     record: true,
    //     ad: true,
    //     bgm: true,
    //     isMustLogin: true,
    //   },
    // },
    {
      path: "/LightUp",
      name: "LightUp",
      component: (resolve) => require(["@/views/LightUp/index"], resolve),
      meta: {
        title: "舞侠 - 点亮周年灯牌",
        login: true,
        download: true,
        enter: true,
        record: true,
        ad: true,
        bgm: true,
        isMustLogin: true,
      },
    },
    //  {
    //   path: "/WishingWell",
    //   name: "WishingWell",
    //   component: (resolve) => require(["@/views/WishingWell/index"], resolve),
    //   meta: {
    //     title: "舞侠 - 许愿池",
    //     login: true,
    //     download: true,
    //     enter: true,
    //     record: true,
    //     ad: true,
    //     bgm: true,
    //     isMustLogin: true,
    //   },
    // },

    // {
    //   path: "/May20th",
    //   name: "May20th",
    //   component: (resolve) => require(["@/views/May20th/index"], resolve),
    //   meta: {
    //     title: "舞侠 - 520",
    //     login: true,
    //     download: true,
    //     enter: true,
    //     record: true,
    //     ad: true,
    //     bgm: true,
    //     isMustLogin: true,

    //   },
    // },
    // {
    //   path: "/BetaRecruit",
    //   name: "BetaRecruit",
    //   component: (resolve) => require(["@/views/BetaRecruit/index"], resolve),
    //   meta: {
    //     title: "舞侠 - 招募",
    //     login: true,
    //     download: true,
    //     enter: true,
    //     record: true,
    //     ad: true,
    //     bgm: true,
    //     isMustLogin: true,
    //   },
    // },

    {
      path: "/404",
      name: "NotFound",
      meta: {
        title: "Page not found",
        isLogin: false,
      },
      component: error,
    },
    // 所有未定义路由，全部重定向到404页，必须放在最后
    {
      path: "*",
      redirect: "/404",
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    // 有页面切换动画或异步内容时，用 Promise 延迟一点，能更可靠回到顶部
    return new Promise((resolve) => {
      // 等一帧或等过渡结束再回到顶部
      setTimeout(() => {
        resolve({ x: 0, y: 0 });
      }, 0);
    });
  },
});
// router.beforeEach((to, from, next) => {
//   if (to.redirectedFrom == "/17173") {

//     // window.location.href = "https://www.baidu.com";

//     localStorage.setItem("17173", to.redirectedFrom);
//      next({
//       path: '/'
//     })
//     console.log(to);
//     location.reload();

//     return;
//   }
//   document.title = to.meta.title; //切换路由改变页面标题
//   if (to.meta.isMustLogin) {
//     if (Cookies.get("wx_token")) {
//       next();
//     } else {
//       Vue.prototype.$message.error("请先登录！");
//       if (from.name == null) {
//         window.location.href = "https://wx.qtthtech.com";

//       }
//     }
//   } else {
//     if (to.name == "Account") {
//       if (Cookies.get("wx_token")) {
//         next();
//       } else {
//         location.href = publicUrl.loginPage;
//       }
//     } else if (to.name == "Register") {
//       if (Cookies.get("wx_token")) {
//         Vue.prototype.$message.error("请先退出当前账户");
//       } else {
//         next();
//       }
//     } else {
//       next();
//     }
//   }
// });
export default router;
